import { render } from "./linux-repair-help.vue?vue&type=template&id=5466c417&scoped=true&ts=true"
import script from "./linux-repair-help.vue?vue&type=script&lang=ts"
export * from "./linux-repair-help.vue?vue&type=script&lang=ts"

import "./linux-repair-help.vue?vue&type=style&index=0&id=5466c417&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5466c417"]])

export default __exports__